import { ColorScale } from 'bold-ui/lib/styles/colors'
import { CardRadioGroupField, CardRadioGroupFieldOption } from 'components/form/field/CardRadioGroupField'
import { Color } from 'csstype'
import { ClassificacaoRiscoEncaminhamentoEnum } from 'graphql/types.generated'
import { MetaPath } from 'util/metaPath'

import { classificacaoRiscoRecord } from './model-encaminhamentoExterno'

export interface ClassificacaoRiscoEncaminhamentoButtonsProps {
  name: MetaPath<ClassificacaoRiscoEncaminhamentoEnum>
}

export function ClassificacaoRiscoEncaminhamentoGroupButton(props: ClassificacaoRiscoEncaminhamentoButtonsProps) {
  const { name } = props

  return <CardRadioGroupField name={name} label='Classificação de risco' options={options} required />
}

const items = Object.entries(classificacaoRiscoRecord)

const options: CardRadioGroupFieldOption<ClassificacaoRiscoEncaminhamentoEnum>[] = items.map(
  ([key, item]: [
    ClassificacaoRiscoEncaminhamentoEnum,
    { label: string; mainColor: Color; colorScale: ColorScale }
  ]) => ({
    label: item.label,
    colorScale: item.colorScale,
    value: key,
  })
)
